import * as React from 'react';
import {View} from 'react-native';
import {ProductsPriceFilterViewBaseProps} from '../../../model';
import {useStyles} from '../../../../../../shared/hooks/styles';
import {CustomScrollView} from '../../../../../../shared/components/scrollView';
import {ProductPriceFilterList} from '../../list';
import {AccordionRewardShop} from '../../../../Accordion';

export const ProductsPriceFilterDesktop: React.FC<ProductsPriceFilterViewBaseProps> = ({productPrices}) => {
  const styles = useStyles(({theme}) => ({
    wrapper: {
      width: `100%`,
      position: 'relative',
      zIndex: 0,
    },
    activateButton: {
      width: `100%`,
      color: 'red',
    },
    filterScrollContainer: {
      maxHeight: 330,
    },
    filterScrollContentContainer: {
      paddingVertical: 20,
      paddingLeft: 20,
    },
    filterButtonContainer: {
      paddingVertical: 12,
      paddingHorizontal: 20,
      alignItems: 'center',
      borderTopWidth: 1,
      borderStyle: 'solid',
      borderTopColor: theme.color.borderColor,
    },
    filterButton: {
      width: 200,
    },
  }));

  return (
    <View style={styles.wrapper}>
      <View style={{width: '100%'}}>
        <AccordionRewardShop title='Цены' accordionId='priceAccordion'>
          <CustomScrollView
            contentContainerStyle={styles.filterScrollContentContainer}
            style={styles.filterScrollContainer}
            {...{dataSet: {class: 'custom-scroll'}}}>
            <ProductPriceFilterList productPrices={productPrices} />
          </CustomScrollView>
        </AccordionRewardShop>
      </View>
    </View>
  );
};
